var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1602 3.06396L21.5498 1.45361L22.4463 0.56543C22.8945 0.133789 23.3926 0.0922852 23.7993 0.499023L24.1147 0.822754C24.5298 1.23779 24.5049 1.72754 24.0566 2.17578L23.1602 3.06396ZM13.5728 12.6265L11.564 13.3901C11.3315 13.4814 11.0742 13.2158 11.1655 12.9751L11.979 11.0244L20.7695 2.24219L22.3633 3.83594L13.5728 12.6265ZM1.37061 13.3237C0.391113 10.2275 3.36279 8.48438 5.5957 7.23096C7.82031 5.98584 8.40137 5.48779 8.19385 4.83203C7.91162 3.94385 4.33398 4.67432 2.3335 5.95264C1.55322 6.41748 0.930664 5.39648 1.64453 4.92334C4.65771 2.89795 8.7998 2.54102 9.40576 4.4668C10.5181 8.11914 1.3623 8.84131 2.59082 12.8589C3.08057 14.5107 6.16846 14.7017 9.47217 13.1577L10.0034 14.2866C5.91943 16.2124 2.15918 15.8057 1.37061 13.3237Z",
    fill: "#101B1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.79376a2c037a723e2ed36b1d848552a6.svg";
export { ForwardRef as ReactComponent };